var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export var SEND_NPS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation SendNPS($token: String!, $score: Int!, $message: String) {\n        sendNPS(Token: $token, Score: $score, Message: $message)\n    }\n"], ["\n    mutation SendNPS($token: String!, $score: Int!, $message: String) {\n        sendNPS(Token: $token, Score: $score, Message: $message)\n    }\n"])));
var templateObject_1;
